module.exports = __webpack_public_path__ + "img/invisible.18309174.png";